// extracted by mini-css-extract-plugin
export default {"header":"Asistentes_header__GbTxF","panel":"Asistentes_panel__G7kwT","panelSection":"Asistentes_panelSection__tmoH8","subHeader":"Asistentes_subHeader__+gTTz"};